"use client";

import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { commonApiPost } from "@/services/api/common-api";
import type { ApiUpdateDropRequest } from "@/generated/models/ApiUpdateDropRequest";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import { ProcessIncomingDropType } from "@/contexts/wave/hooks/useWaveRealtimeUpdater";
interface DropUpdateMutationParams {
  dropId: string;
  request: ApiUpdateDropRequest;
  currentDrop: ApiDrop;
}
export const useDropUpdateMutation = () => {
  const $ = _c(9);
  const {
    setToast
  } = useContext(AuthContext);
  const {
    invalidateDrops
  } = useContext(ReactQueryWrapperContext);
  const myStreamContext = useMyStream();
  let t0;
  if ($[0] !== invalidateDrops || $[1] !== myStreamContext || $[2] !== setToast) {
    t0 = updatedDrop => {
      setToast({
        message: "Drop updated successfully",
        type: "success"
      });
      if (myStreamContext?.processIncomingDrop) {
        myStreamContext.processIncomingDrop(updatedDrop, ProcessIncomingDropType.DROP_INSERT);
      }
      invalidateDrops();
    };
    $[0] = invalidateDrops;
    $[1] = myStreamContext;
    $[2] = setToast;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== setToast) {
    t1 = error => {
      console.error("Failed to update drop:", error);
      const errorMessage = error instanceof Error ? error.message : String(error);
      if (errorMessage.includes("can't be edited after")) {
        setToast({
          message: "This drop can no longer be edited. Drops can only be edited within 5 minutes of creation.",
          type: "error"
        });
      } else {
        setToast({
          message: "Failed to update drop. Please try again.",
          type: "error"
        });
      }
    };
    $[4] = setToast;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = {
      mutationFn: _temp,
      onSuccess: t0,
      onError: t1
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return useMutation(t2);
};
async function _temp(t0) {
  const {
    dropId,
    request
  } = t0;
  return await commonApiPost({
    endpoint: `drops/${dropId}`,
    body: request
  });
}